import { SupportedLanguage } from "../config/languages";

export const buildPageUrl = (
  url: string,
  locale: SupportedLanguage,
): string => {
  // Handle external URLs and anchor links - return as-is
  if (url.startsWith("http") || url.startsWith("//") || url.startsWith("#")) {
    return url;
  }

  // Normalize the URL to always have a leading slash
  const normalizedUrl = url.startsWith("/") ? url : "/" + url;

  // Strip any existing locale prefix to prevent duplication
  const localePattern = /^\/(de|en)(\/|$)/;
  const cleanUrl = normalizedUrl.replace(localePattern, "/");

  if (cleanUrl === "/") {
    return `/${locale}/`;
  }

  return `/${locale}${cleanUrl}`;
};
